// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module__title___36_oB","collapseIcon":"styles-module__collapseIcon___3pOOW"};